module.exports = __webpack_public_path__ + "img/bg1.00bd6761.webp";